function goLoginPage() {
  window.location.href = '/login'
}

export default goLoginPage
